import { Observable } from "rxjs";

import { Headers } from "./Headers";
import { HttpResponse } from "./HttpResponse";

export abstract class IHttpClient {
  public abstract get(url: string, headers?: Headers): Observable<HttpResponse>;
  public abstract post(
    url: string,
    body?: {} | FormData,
    headers?: Headers
  ): Observable<HttpResponse>;
  public abstract put(
    url: string,
    body?: {},
    headers?: Headers
  ): Observable<HttpResponse>;
  public abstract delete(
    url: string,
    headers?: Headers
  ): Observable<HttpResponse>;
}
